<template>
    <div class="contact">
            <h1 class="title">
                <s-l id="home_titleContact">Une question ? Une suggestion ?</s-l>
            </h1>
            <h3 class="subtitle">
                <s-l id="home_subtitleContact">Nous sommes à votre écoute</s-l>
            </h3>
            <div >
                <div class="description">
                    <s-l id="descriptionContact">Vous avez une question ? <br/>Vous souhaitez nous faire part d'une amélioration ? <br/>Vous avez détecter une anomalie ? <br/>Ou vous souhaitez tout simplement rentrer en contact avec nous ?<br/>Supprimer votre compte et vos données ? <br/></s-l>
                </div>
                <div class="buttonContact">
                    <s-button @onclick="setOpenModalContact" label="Contactez nous" theme="is-warning is-medium" />
                </div>
            </div>
            <s-modal
                title="Contactez nous"
                :open="openModalContact"
                :close="true"
                @close="openModalContact=false">
                <div v-if="$store.getters.getUser==null" class="notification is-warning">
                    Il faut vous connecter !
                </div>
                <div v-if="$store.getters.getUser!=null && !sendMailOK"  >
                    <label class="label">
                        Vous souhaitez nous contacter pour :
                      </label>
                        <div class="select is-normal is-primary is-rounded">
                        <select v-model="object">
                            <option value="help">Besoin d'aide sur le fonctionnement ?</option>
                            <option value="evolution">Vous pensez à une évolution ?</option>
                            <option value="anomalie">Vous avez détecté une anomalie ?</option>
                            <option value="supprimer">Vous souhaitez supprimer votre compte et vos données ?</option>
                            <option value="other">Vous souhaitez rentrer en contact</option>
                        </select>
                        </div>
                    <label class="label">
                        Décrivez nous votre besoin :
                    </label>
                    <div style="width:90%">
                    <textarea  v-model="description" class="textarea is-primary is-rounded" rows="5" style="width:100%"/>
                    </div>
                    <br/>
                    <s-button label="Envoyer votre demande" theme="is-primary" @onclick="sendMail"/>
                </div>
                 <div v-if="$store.getters.getUser!=null && sendMailOK"  >
                     Votre demande a bien été envoyée ! L'équipe de petanque-app va vous répondre au plus vite !
                 </div>
            </s-modal>
        </div>
</template>
<style scoped>
@media screen and (max-width: 1025px) {
    .contact {
            margin-top: 40px;
            background-color: var(--bluebg);
            color: white; 
            padding: 10px;
        }
    }
@media screen and (min-width: 1025px) {
     .contact {
        margin-top: 0px;
        background-color: var(--bluebg);
        color: white;    
        height: 250px;
        padding: 10px;
    }
}

.title {
    font-size: 16px;
    font-weight: bolder;
    color: white;
}
.subtitle {
    color: #FFD75C;
    font-size: 20px;
    padding-top: 20px;
    padding-bottom: 0px;
    font-weight: bolder;

}
.description {
    display: inline-block;
    font-size: 16px;
    width: 50%;
    min-width: 350px;
    padding-bottom: 0px;
}
.buttonContact {
    display: inline-block;
    width: 50%;
    min-width: 350px;
    vertical-align:top;
    text-align: center;
}
</style>
<script>
import firebase_api from "@/firebase/firebase_api"
import firebase from "firebase/app";

export default {
    data() {
        return {
            openModalContact: false,
            object: 'help',
            description: null,
            sendMailOK: false
        }
    },
    methods: {
        setOpenModalContact() {
            this.openModalContact = true
            this.sendMailOK = false
        },
         verifyCaptcha(fct) {
            this.$sendRecaptcha( this.$recaptchaLoaded(), this.$recaptcha('contact'), result=>{
                if (result.data.data.success) {
                    fct();
                }
            })
        },
         
        sendMail() {
            
            this.verifyCaptcha(()=>{
              
                if (this.description != null && this.description!='') {
                    var user = this.$store.getters.getUser;
                    var html = user.displayName + ' ' + user.email;
                    html += "<br/>" + this.description;
                  
                    firebase_api.api.getDb().collection('mail').add({
                        to: 'lbaillet.pro@gmail.com, contact@petanque-app.com', 
                        message: {
                            subject: this.object,
                            html: html
                        },
                        group: "CONTACT_MAIL"
                    })
                    this.sendMailOK = true
                }
            })
            
            
        }
    }
    
}
</script>